import axios from "axios";
import { dynamicFailed } from "../hooks/useToast";
import { headers } from "../exports/exports";

export const checkUser = async (accessToken: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/user`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return response;
  } catch (error) {
    // dynamicFailed("Server Error");
  }
};

export const fetchUserById = async (id: number) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-users?filters[sis_id][$eq]=${id}&populate[Profile_Picture][populate]=*&populate[Payment_Reciept][populate]=*&populate[frcsit_user_operations][populate]=*&populate[bi_frcsit_user_upload][populate]=*&populate[frcsit_notices][populate]=*`,
      { headers },
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const checkEmailExists = async (email: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-users?filters[Email][$eq]=${email}`,
      { headers },
    );

    return response.data.data.length > 0;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const checkPhoneExists = async (phone: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-users?filters[Mobile_Number][$eq]=${phone}`,
      { headers },
    );

    return response.data.data.length > 0;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const deleteFromUser = async (sisuserId: number, sisheaders: any, userId: number) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/admin/users/${sisuserId}`,
      {
        headers:  sisheaders,
      },
    );
    if (userId) {
      await axios.delete(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${userId}`,
        { headers }
      );
    }

  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};
